import { View } from 'tamagui'
import CoreEditUser from './editUser/coreEditUser'

export default function AddUserPage() {
    return (
        <View
            paddingHorizontal="$6"
            $sm={{ paddingHorizontal: '$4' }}
        >
            <CoreEditUser />
        </View>
    )
}
